import { render, staticRenderFns } from "./ProjectCost.vue?vue&type=template&id=981cfcae&scoped=true"
import script from "./ProjectCost.vue?vue&type=script&lang=js"
export * from "./ProjectCost.vue?vue&type=script&lang=js"
import style0 from "./ProjectCost.vue?vue&type=style&index=0&id=981cfcae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "981cfcae",
  null
  
)

export default component.exports